/**
 * UD Event Design Tool Api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import {createAction} from '@reduxjs/toolkit';
import {ApiMethods, ConcurrentStrategies} from '@pb/middleware-api';
import {PayloadData} from '../types';
import type {ChangeRequestReview} from '../models/ChangeRequestReview';
import type {Error} from '../models/Error';

export interface GetChangeRequestReviewById$Request {
    changeRequestId: number;
}

export interface GetChangeRequestReviewById$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const getChangeRequestReviewByIdRequest = createAction<PayloadData<void, GetChangeRequestReviewById$Request>>('CHANGE_REQUEST_REVIEW_CONTROLLER__GET_CHANGE_REQUEST_REVIEW_BY_ID__REQUEST');
export const getChangeRequestReviewByIdSuccess = createAction<PayloadData<ChangeRequestReview, GetChangeRequestReviewById$Request>>('CHANGE_REQUEST_REVIEW_CONTROLLER__GET_CHANGE_REQUEST_REVIEW_BY_ID__SUCCESS');
export const getChangeRequestReviewByIdFailure = createAction<PayloadData<Error, GetChangeRequestReviewById$Request, true>>('CHANGE_REQUEST_REVIEW_CONTROLLER__GET_CHANGE_REQUEST_REVIEW_BY_ID__FAILURE');

export const getChangeRequestReviewByIdActions = [
    getChangeRequestReviewByIdRequest,
    getChangeRequestReviewByIdSuccess,
    getChangeRequestReviewByIdFailure
] as const;

/**
 * @param {number} meta.changeRequestId Change Request Id
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const getChangeRequestReviewById = (meta: GetChangeRequestReviewById$Request, config?: GetChangeRequestReviewById$Config) => {
    return {
        CALL_API: {
            types: getChangeRequestReviewByIdActions,
            method: ApiMethods.GET,
            endpoint: `/ai/change-request-review/${meta.changeRequestId}`,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Accept': 'application/json',
            }
        },
        ...meta
    }
};

